
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../FileFinder/FileFinderTypes";
import "../../moreCore/UI/Button/Button";
import { EmploymentPropositionTypes } from "./OE_Types";
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import { WindowHelpers } from "../../more/Helpers";
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import { VAM2types } from "../_loadingHelpers/VAMv2Types";

//import "../EmploymentProposition/EmploymentPropositionTypes";
class OE_EmploymentStatusFinder extends compose(FinderBaseV2) {

    //selectRegistry: Array<SearchSelect> = [];
    private inputRegistry: Record<string, { widget: MdsLax<InstanceType<typeof RadioGroup>>, targetValue: any, node: HTMLElement, tableRow: HTMLElement }> = {};

    private _availableValues;
    private tableIsReady: boolean = false;


    protected _tableLayouts: Array<StaticTable.Layout> = [{
        "name": "default",
        "label": "Default",
        layoutStyle: "auto",
        rows: [{
            "attributes": [
                "ev_project_name",
                "ref_artistic_period.description",
                "date_from",
                "date_to",
                ""
            ],
            "headings": [
                (this as any).translations["EmploymentProposition_TableColHead_ProjectName"],
                (this as any).translations["EmploymentProposition_TableColHead_ArtisticPeriod"],
                (this as any).translations["EmploymentProposition_TableColHead_DateFrom"],
                (this as any).translations["EmploymentProposition_TableColHead_DateTo"],
                (this as any).translations["EmploymentProposition_TableColHead_Proposition"],
            ],
            "colNamesInternal": [
                "project",
                "artisticPeriod",
                "date_from",
                "date_to",
                "proposition"
            ]
        },{
            "attributes": [
                ""
            ],
            "colspans": [
                5
            ],
            "headings": [
                "EmploymentProposition_TableColHead_ConfirmedProposition"
            ],
            "colNamesInternal": [
                "confirmedProp",
            ]
        }]
        
    }]

    table_Formatter(cell: StaticTable.StaticTableCell<EmploymentPropositionTypes.EvProjectWithProposition>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        //let index = cell.tableRow.lineIndex;
        let value = cell.value;
        let index = cell.tableRow.rowGroup.rowIndex;

        switch (colName) {
            case "status_orchester_employment_registration":
                this.inputRegistry[entity.ID] = {
                    tableRow: cell.tableRow.node,
                    node: node,
                    targetValue: entity.status_orchester_employment_registration,
                    widget: null
                };

                //let select = new SearchSelect();

                //this.getProjectStatusList(select, { value: "" + entity.status_orchester_employment_registration, label: entity.$status_orchester_employment_registration });
                //this.UiModder.domClass.add(node, "searchSelectColumn");

                //select.placeAt(node);
                //this.UiModder.domAttr.set(select.domNode, "index", index);
                //this.selectRegistry.push(select);
                return true;
                break;
            default:
                return false;
        }
    }

    private getProjectStatusList(): void {
        this.RequestManager.callfunction("Webtool_API_OrchestraEmploymentProposition__GetProjectStatusObjectList",
            null,
            lang.hitch(this, this.onProjectStatusListResponse),
            lang.hitch(this, this.onProjectStatusListError));
    }

    private onProjectStatusListResponse(response): void {
        this._availableValues = response;
        this.applyRadiobuttonValues();
    }

    private onProjectStatusListError(error): void {
        setTimeout(lang.hitch(this, this.getProjectStatusList), 8000);
    }

    protected _onTableCreated(table: MdsLax<InstanceType<typeof StaticTable>>) {
        super._onTableCreated.apply(this, arguments as any);

        //this.selectRegistry = [];
        

        //table.addCustomRowActionButton("save", lang.hitch(this, this._onClickSaveStatus), "fas fa-save");

    }

    protected _beforeTableDrawn(table: MdsLax<InstanceType<typeof StaticTable>>) {
        super._beforeTableDrawn.apply(this, arguments as any);

        this.tableIsReady = false;
        this.inputRegistry = {};
    }


    protected _onTableDrawn(table: MdsLax<InstanceType<typeof StaticTable>>) {
        super._onTableDrawn.apply(this, arguments as any);

        //this.UiModder.domStyle.set(table.tableRoot, "overflow", "visible");

        this.tableIsReady = true;

        this.applyRadiobuttonValues();
    //    this.selectRegistry.sort((a, b) => {
    //        return this.UiModder.domAttr.get(a.domNode, "index") - this.UiModder.domAttr.get(b.domNode, "index");
    //    });
    }

    private applyRadiobuttonValues() {
        
        if (!this.tableIsReady || !this._availableValues) return;
        let values = Object.keys(this.inputRegistry);
        for (let key of values) {
            let entry = this.inputRegistry[key];

            let radio = new RadioGroup({ entries: [], alignment: "horizontal"});
            entry.widget = radio;

            radio.placeAt(entry.node);

            radio.setMandatory(true);
            
            radio.setData("" + entry.targetValue, this._availableValues, true, "label", "value");

            radio.on("change", lang.hitch(this, this._onChange_RadioValue, key))
                        
            radio.setReadonly(false);
        }
    }

    private _onChange_RadioValue(key: string, value) {
        let entry = this.inputRegistry[key];

        value = entry.widget.getValue();

        let jsonData = {
            statusValue: value,
            projectID: key
        }

        this.hourGlassStart(entry.node);

        this.RequestManager.callfunction("Webtool_API_OrchestraEmploymentProposition__SaveProjectStatus",
            jsonData,
            lang.hitch(this, this._onSaveProjectStatusResponse, key),
            lang.hitch(this, this._onSaveProjectStatusError, key));
    }
    private _onClickSaveStatus(data: StaticTable.StaticTableRowGroup<VAM2types.EvProjectEntity_Base>): void {
        //let select = this.selectRegistry[data.rowIndex];
        //let value = select.getValue();

        let radio = this.inputRegistry[data.entity.ID].widget as MdsLax<InstanceType<typeof RadioGroup>>;
        
        let value = radio.getValue("value");
        let entityId = data.entity.ID;

        let jsonData = {
            statusValue: value,
            projectID: entityId
        }

        this.RequestManager.callfunction("Webtool_API_OrchestraEmploymentProposition__SaveProjectStatus",
            jsonData, lang.hitch(this, this._onSaveProjectStatusResponse, null),
            lang.hitch(this, this._onSaveProjectStatusError, null));
    }

    private _onSaveProjectStatusResponse(key: string, response) {
        if (key) {
            let entry = this.inputRegistry[key];
            this.hourGlassEnd(entry.node);
        }

        this.showToast("General_SavingSuccessful", toasterIcons.confirmCheck, key);
        //this.reload();
    }

    private _onSaveProjectStatusError(key: string, error: more.requestErrorMessage) {
        console.error(error);
        this.showToast({
            title: "General_SavingFailed",
            message: error.Message,
            iconClass: toasterIcons.error,
            ID: key
        });
        if (key) {
            let entry = this.inputRegistry[key];
            this.hourGlassEnd(entry.node);
        }
       
    }
 
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API_OrchestraEmploymentProposition_GetEmploymentStatusFinderConfig",
            "Webtool_API_OrchestraEmploymentProposition__GetStatusProjectList",
            null,
            lang.hitch(this, this.table_Formatter), // Standard-Formatter
            null,
        );


        WindowHelpers.setTitles("OrchestraEmploymentProposition_Label__Status");   
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.getProjectStatusList();
        //
         
    }
}

export default mdsWidget(OE_EmploymentStatusFinder);
